import React, { Fragment } from "react";

const MessageUserItem = ({
  user,
  messages,
  setUserObject,
  setconvosoverlay,
}) => {
  let currentConvo;

  if (messages && messages.length > 0) {
    currentConvo = messages.map((message) => {
      if (message.channelid === user.channelid) {
        return [...message.messages];
      }
    });
  }

  return (
    <Fragment>
      {user.role === "innovator" && (
        <div
          className="user-section"
          onClick={() => {
            setUserObject({
              user: user.user,
              channelid: user.channelid,
              role: user.role,
              avatar: user.avatar,
              firstname: user.firstname,
              lastname: user.lastname,
              jobtitle: user.jobtitle,
              location: user.location,
              messages: messages && messages.length > 0 ? currentConvo[0] : [],
            });
            setconvosoverlay(true);
          }}
        >
          <div className="friends-user-container">
            <div className="friend-user-avi-container">
              <div className="avi-color-border green">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                  className="friend-user-avi"
                />
              </div>
            </div>
            <div className="friend-user-info">
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="green name-font">{user.channelid}</span>
                  </li>
                  <li className="user-online-item">
                    {user.firstname} {user.lastname}
                  </li>
                  <li className="user-online-item">{user.jobtitle}</li>
                  <li className="user-online-item">
                    {user.location.city}, {user.location.state}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="friends-buttons-container">
            <div className="friend-button-container">
              <button className="friend-button background-green">
                <i className="far fa-comments mx-5"></i>
                Message
              </button>
            </div>
          </div>
        </div>
      )}
      {user.role === "mentor" && (
        <div
          className="user-section"
          onClick={() => {
            setUserObject({
              user: user.user,
              channelid: user.channelid,
              role: user.role,
              avatar: user.avatar,
              firstname: user.firstname,
              lastname: user.lastname,
              jobtitle: user.jobtitle,
              location: user.location,
              messages: messages && messages.length > 0 ? currentConvo[0] : [],
            });
            setconvosoverlay(true);
          }}
        >
          <div className="friends-user-container">
            <div className="friend-user-avi-container">
              <div className="avi-color-border red">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                  className="friend-user-avi"
                />
              </div>
            </div>
            <div className="friend-user-info">
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="red name-font">{user.channelid}</span>
                  </li>
                  <li className="user-online-item">
                    {user.firstname} {user.lastname}
                  </li>
                  <li className="user-online-item">{user.jobtitle}</li>
                  <li className="user-online-item">
                    {user.location.city}, {user.location.state}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="friends-buttons-container">
            <div className="friend-button-container">
              <button className="friend-button background-red">
                <i className="far fa-comments mx-5"></i>
                Message
              </button>
            </div>
          </div>
        </div>
      )}
      {user.role === "employer" && (
        <div
          className="user-section"
          onClick={() => {
            setUserObject({
              user: user.user,
              channelid: user.channelid,
              role: user.role,
              avatar: user.avatar,
              companyname: user.companyname,
              firstname: user.firstname,
              lastname: user.lastname,
              location: user.location,
              messages: messages && messages.length > 0 ? currentConvo[0] : [],
            });
            setconvosoverlay(true);
          }}
        >
          <div className="friends-user-container">
            <div className="friend-user-avi-container">
              <div className="avi-color-border blue">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                  className="friend-user-avi"
                />
              </div>
            </div>
            <div className="friend-user-info">
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="blue name-font">{user.companyname}</span>
                  </li>
                  <li className="user-online-item">{user.channelid}</li>
                  <li className="user-online-item">
                    {user.firstname} {user.lastname}
                  </li>
                  <li className="user-online-item">
                    {user.location.city}, {user.location.state}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="friends-buttons-container">
            <div className="friend-button-container">
              <button className="friend-button background-blue">
                <i className="far fa-comments mx-5"></i>
                Message
              </button>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default MessageUserItem;
